import React from 'react';
import { connect } from 'react-redux';
import LinkButton from '../../Basic/LinkButton';
import ContactPersonFull from './ContactPersonFull';
class MoreContactPerson extends React.Component {
    constructor(props) {
        console.log("MoreContactPerson Cons");
        super(props);
        const contactsId = props.contactsId || [];
        const contacts = contactsId.map((p, i) => {
            return (
                <ContactPersonFull key={i} name={`aditionalContactPerson${p}`}
                    disabled={props.form[`aditionalContactPerson${p}Saved`]} />
            );
        });
        this.state = {
            contacts,
            contactsId
        };
    }
    onDelete = (i) => {
        let contacts = [...this.state.contacts];
        contacts.splice(i, 1);
        let contactsId = [...this.state.contactsId];
        contactsId.splice(i, 1);
        this.setState({ contacts, contactsId });
        this.props.dispatch({ type: "MORE_CONTACT_PERSON", moreContactPersonIds: contactsId });
    };
    onAdd = () => {
        const s = this.state;
        const p = this.props;
        let id = 1;
        if (s.contactsId.length != 0)
            id = s.contactsId[s.contactsId.length - 1] + 1;
        const newContact = (
            <ContactPersonFull name={`aditionalContactPerson${id}`} disabled={p.form[`aditionalContactPerson${id}Saved`]} />
        );
        const contacts = [...s.contacts, newContact];
        const contactsId = [...s.contactsId, id];
        this.setState({ contactsId, contacts });
        p.dispatch({ type: "MORE_CONTACT_PERSON", moreContactPersonIds: contactsId, newContactId:id });
    };
    render() {
        const s = this.state;
        const p = this.props;
        let content = [];
        for (let i = 0; i < s.contacts.length; i++) {
            content.push(
                <div>
                    <h4 className="row">
                        <span className="col-sm-5">{`Additional Contact ${i + 1}`}
                            <LinkButton text="Delete" onClick={() => this.onDelete(i)} isSimple
                                disabled={p.form[`aditionalContactPerson${s.contactsId[i]}Saved`]} />
                        </span>
                    </h4>
                    {s.contacts[i]}
                </div>
            );
        }
        return (
            <div className="form-group">
                {content}
                <div>
                    <LinkButton text="<i class='fa fa-plus-square' style='color:#428BCA'></i> Add another contact"
                        onClick={() => this.onAdd()} isSimple disabled={p.disabled} />
                </div>
            </div>
        );
    }
}
MoreContactPerson.propTypes = {
    moreContactPersonCount: React.PropTypes.number,
    contacts: React.PropTypes.array,
    contactsId: React.PropTypes.array,
    disabled: React.PropTypes.bool
};
const mapStateToProps = (state) => {
    return {
        form: state.form,
        contactsId: state.form.moreContactPersonIds
    };
};
export default connect(mapStateToProps)(MoreContactPerson);